import { type StateCreator } from "zustand";

export type ThemePreference = "system" | "light" | "dark";
export type ResolvedTheme = "light" | "dark";

export interface ThemeState {
  themePreference: ThemePreference;
  resolvedTheme: ResolvedTheme;
  accentColor: string;
}

export interface ThemeActions {
  setThemePreference: (pref: ThemePreference) => void;
  setResolvedTheme: (theme: ResolvedTheme) => void;
  setAccentColor: (color: string) => void;
}

export type ThemeSlice = ThemeState & ThemeActions;

export const createThemeSlice: StateCreator<ThemeSlice, [], [], ThemeSlice> = (set) => ({
  themePreference: "system",
  resolvedTheme: "light",
  accentColor: "blue",
  setThemePreference: (pref) => set({ themePreference: pref }),
  setResolvedTheme: (theme) => set({ resolvedTheme: theme }),
  setAccentColor: (color) => set({ accentColor: color }),
});
